module.exports = __webpack_public_path__ + "img/dell.9c7829bf.svg";